/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Secret } from "./Secret";
export const SecretsResponse = core.serialization.object({
    data: core.serialization.list(Secret),
});
